// extracted by mini-css-extract-plugin
export default {"root":"_2tDH7","input":"_3Mad-","label":"wfxc3"};